import { render, staticRenderFns } from "./SalesLimit.template.vue?vue&type=template&id=ff193082&scoped=true&"
var script = {}
import style0 from "./SalesLimit.template.vue?vue&type=style&index=0&id=ff193082&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff193082",
  null
  
)

export default component.exports